import { useQueryClient } from '@tanstack/react-query'
import { type EntityId, Logger } from '@terros/common'
import { useCallback, useMemo } from 'react'
import { entitlementsKey } from './key'

const logger = new Logger('useEntitlementCache')

logger.level = 'verbose'

type EntitlementCache = {
  clearList: (entityId?: EntityId) => void
}

export function useEntitlementCache(): EntitlementCache {
  const queryClient = useQueryClient()

  const clearList = useCallback(
    (entityId?: EntityId) => {
      logger.verbose('invalidateQueries entitlementsKey')
      queryClient.invalidateQueries({ queryKey: entitlementsKey(entityId) })
    },
    [queryClient]
  )

  return useMemo(() => {
    return { clearList }
  }, [clearList])
}
